function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import Bulma from '../core';
import DismissableComponent from '../dismissableComponent';
/**
 * @module Notification
 * @since  0.1.0
 * @author  Thomas Erbe <vizuaalog@gmail.com>
 * @extends DismissableComponent
 */

var Notification = /*#__PURE__*/function (_DismissableComponent) {
  _inherits(Notification, _DismissableComponent);

  var _super = _createSuper(Notification);

  /**
   * Plugin constructor
   * @param  {Object} options The options object for this plugin
   * @return {this} The newly created instance
   */
  function Notification(options) {
    var _this;

    _classCallCheck(this, Notification);

    _this = _super.call(this, 'notification', options); // TODO: Move this into the DismissableComponent class. Due to the required
    // changes between different components, we may need a way to trigger this
    // when the component is ready.

    if (_this.isDismissable) {
      if (!options.hasOwnProperty('closeButton')) {
        _this.prependCloseButton();
      }

      _this.setupCloseEvent();
    }

    return _this;
  }

  _createClass(Notification, null, [{
    key: "create",
    value:
    /**
     * Helper method used by the Bulma core to create a new instance.
     * @param  {Object} options The options object for this instance
     * @return {Notification} The newly created instance
     */
    function create(options) {
      return new Notification(options);
    }
    /**
     * Handle parsing the DOMs data attribute API.
     * @param {HTMLElement} element The root element for this instance
     * @return {undefined}
     */

  }, {
    key: "parse",
    value: function parse(element) {
      var closeBtn = element.querySelector('.delete');
      var dismissInterval = element.getAttribute('data-dismiss-interval');
      var options = {
        body: null,
        parent: element.parentNode,
        element: element,
        closeButton: closeBtn,
        isDismissable: !!closeBtn,
        destroyOnDismiss: true
      };

      if (dismissInterval) {
        options['dismissInterval'] = parseInt(dismissInterval);
      }

      new Notification(options);
    }
    /**
     * Returns a string containing the element class this plugin supports.
     * @returns {string} The class name.
     * @throws {Error} Thrown if this method has not been replaced.
     */

  }, {
    key: "getRootClass",
    value: function getRootClass() {
      return 'notification';
    }
  }]);

  return Notification;
}(DismissableComponent);

Bulma.registerPlugin('notification', Notification);
export default Notification;